import React  from "react";
import { Modal } from "react-bootstrap"; 
// eslint-disable-next-line 
import Editor from "./Editor";

import PropTypes from "prop-types";
const MonacoEditorPopup = ({ show, handleClose }) => { 

  

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Code Editor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
       <Editor/>  
      </Modal.Body>
     
    </Modal>
  );
};

MonacoEditorPopup.propTypes = {
  show: PropTypes.any.isRequired,
  handleClose: PropTypes.any.isRequired,
};
export default MonacoEditorPopup;